<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="text-h6">Gestión de Vehículos</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openDialog('create')">
          <v-icon>mdi-plus</v-icon> Agregar Vehículo
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="vehicles"
        item-value="id"
        dense
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <hr />
    <br />

    <!-- Diálogo para Agregar/Editar Vehículo -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <VehicleForm
            :mode="dialogMode"
            :vehicleData="selectedVehicle"
            @save="handleSave"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
  <script>
import VehicleForm from "../components/VehicleForm.vue"; // Importa tu formulario
import axios from "@/plugins/axios.js";

export default {
  name: "Test",
  components: {
    VehicleForm,
  },
  data() {
    return {
      vehicles: [], // Lista de vehículos desde la API
      dialog: false,
      dialogTitle: "",
      dialogMode: "create", // 'create' o 'edit'
      selectedVehicle: {}, // Datos del vehículo seleccionado
      headers: [
        { text: "Patente", value: "plate" },
        { text: "Marca", value: "make" },
        { text: "Modelo", value: "model" },
        { text: "Año", value: "year" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    this.getVehicles();
  },
  methods: {
    async getVehicles() {
      try {
        const response = await axios.get("/vehicles/getVehicles");
        this.vehicles = response.data;
      } catch (error) {
        console.error("Error al obtener vehículos", error);
      }
    },
    openDialog(mode, vehicle = {}) {
      this.dialogMode = mode;
      this.selectedVehicle = { ...vehicle };
      this.dialogTitle =
        mode === "create" ? "Agregar Vehículo" : "Editar Vehículo";
      this.dialog = true;
    },
    async handleSave(vehicle) {
      try {
        if (this.dialogMode === "create") {
          await axios.post("/vehicles/create", vehicle);
        } else {
          await axios.put(`/vehicles/update/${vehicle.id}`, vehicle);
        }
        this.getVehicles(); // Recargar la lista
        this.dialog = false;
      } catch (error) {
        console.error("Error al guardar vehículo", error);
      }
    },
  },
};
</script>
  